import React from 'react';

import Card from '../../components/common/Card';
import AdminLayout from '../../components/layout/AdminLayout';
import HomeCoursesTable from '../../components/member/HomeCoursesTable';

// The desktop page for the member's home courses. The table itself (add, remove, show or hide)
// is HomeCoursesTable, which is also the Home tab of the profile's golf lists, the phone's way in.
const HomeCourses: React.FC = () => (
  <AdminLayout
    activeMenuItem="/member/home-courses"
    breadcrumbs={[
      { label: 'My Profile', href: '/member/profile' },
      { label: 'Home Courses', href: '#' },
    ]}
    allowedRoles={['User']}
  >
    <Card title="Home Courses">
      <HomeCoursesTable />
    </Card>
  </AdminLayout>
);

export default HomeCourses;
